import React,  {useState} from 'react'

import './roomcard.css'

import {Button, Modal} from 'antd'

const RoomCard = ({title, title2, image, color, setBookingScreen, ammenities, setRoomBookedId, id}) => {
	const [openCard, setOpenCard] = useState(false)
	const [modalOpen, setModalOpen] = useState(false)
	
	const handleOpenCard = () => {
		setOpenCard(!openCard)
	}
	
	const handleOpenModal = () => {
		setModalOpen(!modalOpen)
	}
	
	const handleBooking = () => {
		setBookingScreen(true)
		setRoomBookedId({id: id, name: title2 ? title + ', ' + title2 : title})
	}
	
	return (
		<div className="roomcard" style={{height: openCard ? '281px' : '109px', backgroundImage: 'url(' + image + ')', backgroundColor: color}} >
			<div style={{height: openCard ? '281px' : '109px', position: 'absolute', width: '100%'}} onClick={handleOpenCard}></div>
			<div className="titlecard" style={{paddingTop: openCard ? '33px' : '12px'}}>
				<p>{title}</p>
				<span>{title2}</span>
			</div>
			<div className="buttonscard">
				<Button className="detailsbtn" style={{width: '260px'}} onClick={() => setModalOpen(true)}>VER DETALLES Y RESERVAR</Button>
			</div>
			<Modal 
				open={modalOpen}
				onCancel={() => setModalOpen(false)}
				className="modalroom"
				closeIcon={false}
				footer={null}
			>
				<div className="modalroomtitle">DETALLES SALA</div>
				<div className="ammenitieswrap">
					{ammenities.map((value, key) => <AmmenityInfo ammenity={value} key={key} /> )}
				</div>
				<div className="amenitiesAdvice">
					<span>Possible material addicional sota petició.</span>
				</div>
				<div className="buttonscard" style={{marginTop: '20px'}}>
				<Button className="bookbtn" onClick={handleBooking}>Reservar sala</Button>
				</div>
			</Modal>
		</div>
	)
}


export const AmmenityInfo = ({ammenity}) => {
	return (
		<div className="ammenity">
			<img src={ammenity.iconMobile} alt="icon" style={{width: '24px', height: '24px'}}/>
			<span>{ammenity.text}</span>
		</div>
	)
}

export default RoomCard